module.exports = __webpack_public_path__ + "media/GothaProMed.dd3d9ca5.otf";


//////////////////
// WEBPACK FOOTER
// ./fonts/GothaProMed.otf
// module id = 98
// module chunks = 9